import {
  Box,
  Button,
  Flex,
  HStack,
  Image,
  Text,
  Grid, GridItem,
  IconButton
} from "@chakra-ui/react";
import { Stack } from "@chakra-ui/react";
import { FaArrowLeft, FaArrowRight, FaPlay } from "react-icons/fa";
import { FaGamepad, FaLanguage, FaFileAlt } from "react-icons/fa";
import { Link as RouterLink, useLocation } from "react-router-dom";

import Smart from "../../assets/homeImage/smart.png";
import Protection from "../../assets/homeImage/protection.png";
import Rewards from "../../assets/homeImage/rewards.png";
import UI from "../../assets/homeImage/ui.png";
import Community from "../../assets/homeImage/community.png";

import Ludo from "../../assets/ludo.png";
import Pokar from "../../assets/poker.png";
import Pool from "../../assets/pool.png";
import Rummy from "../../assets/rummy.png";
import Leaderboard from "../../assets/leaderboard.png";
import Victory from "../../assets/victory.png";
import Home from "../../assets/Fig.png";

import { DownloadIcon } from "@chakra-ui/icons";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { useEffect } from "react";
import DisclaimerPopup from "./DesclaimerPopup.js";
import Fantasy from "../../assets/fantancy.png";
import Cricket from "../../assets/cricketimg.png";
import { useRef } from "react";
import Game from "../Home/HomeHero.js";
import TrendingStories from "../../components/Testimonials/Testimonials.js";



const HomeBanner = () => {
  const swiperRef = useRef(null);
  const gradientTextStyle = {
    fontSize: "30px",
    fontWeight: 700,
    fontFamily: "Barlow, sans-serif",
    background: "linear-gradient(#FAECA4 25%, #B5763A 100%)",
    WebkitBackgroundClip: "text",
    color: "transparent",
    WebkitTextStroke: "2px #5c2d06",
  };

  const values = [
    {
      icon: Protection,
      title: "100% Secure & Trusted ",
      description:
        "Transparent gameplay, verified payouts, and encrypted transactions.",
    },
    {
      icon: Smart,
      title: "Smart & Skill-Based ",
      description: "Win with skill, not luck. Every decision matters.",
    },
    {
      icon: Rewards,
      title: "Non-Stop Rewards",
      description: "Cashback, contests, leaderboards, and referral bonuses.",
    },
    {
      icon: UI,
      title: "Stunning UI/UX",
      description:
        "Futuristic design that feels like you're gaming in a galaxy of your own.",
    },
    {
      icon: Community,
      title: "Community-Powered ",
      description:
        "Chat, challenge, and grow with fellow players across India.",
    },
  ];
  const downloadFile = () => {
    const fileUrl =
      "https://play.google.com/store/apps/details?id=com.PurpleFoxLeisurePrivateLimited.winnsta";
    const link = document.createElement("a");
    // link.href = fileUrl;
    link.download = "Winnsta App";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  };

  const openTrailer = () => {
    const youtubeUrl = "https://www.youtube.com/@WinnstaApp";
    // or channel link
    // const youtubeUrl = "https://www.youtube.com/@yourchannel";

    window.open(youtubeUrl, "_blank", "noopener,noreferrer");
  };


  const routerLocation = useLocation();

  useEffect(() => {
    if (routerLocation.hash === "#games") {
      const el = document.getElementById("games-section");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [routerLocation]);



  const games = [
    { name: "ludo", image: Ludo },
    { name: "poker", image: Pokar },
    { name: "rummy", image: Rummy },
    { name: "pool", image: Pool },
    { name: "fantasy", image: Fantasy },
    { name: "cricket", image: Cricket }
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ],
  };


  return (

    <Box
      // px={{ base: 14, md: 16 }}
      mx="auto"
      position="relative"
      overflow="hidden"
      bg="#050008"
    >
      {/* Section 1: Banner */}
      <DisclaimerPopup />

      <Grid

        mx="auto"                         // center grid horizontally
        // px={{ base: 14, md: 16 }}

        templateColumns={{ base: "1fr", md: "1fr 1fr" }}
        w="100%"
        gap={{ base: 4, md: 1 }}
        alignItems="flex-start"                      // align items to the top
        justifyContent="space-between"               // center vertically
      >
        {/* Text Column */}
        <GridItem px={{ base: 2, md: 16 }} pt={{ base: 4, md: 6 }} position="relative">
          {/* Left Glow Effect */}
          <Box
            position="absolute"
            top="40%"
            left="-20%"
            transform="translate(-30%, -40%)"
            w={{ base: "300px", md: "700px" }}
            h={{ base: "300px", md: "700px" }}
            bg="radial-gradient(circle, #8B5CF6 0%, rgba(0,0,0,0) 70%)"
            filter="blur(120px)"
            opacity={0.5}
            zIndex={0}
            pointerEvents="none"
          />
          <Flex
            direction="column"
            justify="center"              // center content vertically
            h="100%"
            w={{ md: 700 }}
            position="relative"
            zIndex={1}
          >
            <Text
              fontSize={{ base: "40px", md: "60px" }}
              mb={2}
              bgGradient="linear(to-r, #FFFFFF, #A78BFA)"
              bgClip="text"
              fontWeight="bold"
              textAlign={{ base: "center", md: "left" }}   // center on mobile
            >
              Think Fast Winn Fast!
            </Text>

            <Text
              fontSize={{ base: "14px", md: "21px" }}
              mb={4}
              color="#fff"

              lineHeight="1.8"

              textAlign={"start"}   // center on mobile
            >
              Welcome to Winnsta, your ultimate destination for next-gen fantasy sports and engaging casual battles. Welcome to the digital where every move counts, every decision matters, and every player has a chance to shine. Step into a cutting-edge digital universe where sports enthusiasts and casual gamers unite to experience unmatched thrill, strategy, and reward. Winnsta isn't just another gaming platform.
            </Text>

            <Text
              fontSize={{ base: "35", md: "45" }}
              mb={6}
              color="#A78BFA"
              fontWeight="bold"
              textAlign={{ base: "center", md: "left" }}   // center on mobile
            >
              No Real Money Only Skill Based.
            </Text>

            <Box py={2}>
              <Stack direction={{ base: "row", md: "row" }} spacing={6} justify={{ base: "center", md: "flex-start" }}>
                <Button
                  onClick={downloadFile}

                  backgroundColor="#8B5CF6"
                  color="white"
                  px={6}
                  borderRadius="full"
                  border={"2px solid #8B5CF6 "}
                  _hover={{
                    bg: "#8B5CF6",
                    transform: "scale(1.1)",
                    borderColor: "#8B5CF6",         // 👈 only color changes, not size
                  }}
                  _active={{ bgGradient: "#8B5CF6" }}
                  _focus={{ boxShadow: "none" }}
                  leftIcon={<DownloadIcon />}
                >
                  Play Now
                </Button>

                <Button
                  onClick={openTrailer}
                  backgroundColor="transparent"
                  color="white"
                  px={6}
                  border="2px solid #8B5CF6"
                  borderRadius="full"
                  _hover={{ backgroundColor: "#8B5CF6" }}
                  _active={{ backgroundColor: "transparent" }}
                  _focus={{ boxShadow: "none" }}
                  leftIcon={<FaPlay />}
                >
                  Watch Trailer
                </Button>
              </Stack>
            </Box>

            {<Box>
              <Stack
                direction={{ base: "row", md: "row" }}
                spacing={8}
                align="center"
                justify={{ base: "center", md: "flex-start" }}
                mt={4}
              >

                <Flex align="center" gap={{ base: 1, md: 3 }}>
                  <Box w="35px" h="35px" display="flex" alignItems="center" justifyContent="center" borderRadius="xl" bg="#9CA3AF">
                    <FaGamepad color="#000" size={20} />
                  </Box>
                  <Box>
                    <Text color="white" fontWeight="bold">Casual</Text>
                    <Text color="gray.400" fontSize="sm">Genre</Text>
                  </Box>
                </Flex>


                <Flex align="center" gap={{ base: 1, md: 3 }}>
                  <Box w="35px" h="35px" display="flex" alignItems="center" justifyContent="center" borderRadius="xl" bg="#9CA3AF">
                    <FaLanguage color="#000000" size={20} />
                  </Box>
                  <Box>
                    <Text color="white" fontWeight="bold">English</Text>
                    <Text color="gray.400" fontSize="sm">Language</Text>
                  </Box>
                </Flex>


                <Flex align="center" gap={{ base: 1, md: 3 }}>
                  <Box w="35px" h="35px" display="flex" alignItems="center" justifyContent="center" borderRadius="xl" bg="#9CA3AF">
                    <FaFileAlt color="#000" size={20} />
                  </Box>
                  <Box>
                    <Text color="white" fontWeight="bold">174 MB</Text>
                    <Text color="gray.400" fontSize="sm">File Size</Text>
                  </Box>
                </Flex>
              </Stack>
            </Box>}
          </Flex>
        </GridItem>

        {/* Image Column */}
        <GridItem position={'relative'} pt={{ base: 4, md: 6 }} >
          <Image src={Home} alt="Banner" mx="auto" transform="scale(1.15)" transformOrigin="top center" />
          <Box
            position="absolute"
            top="110%"
            right="-40%"
            transform="translate(-60%, -60%)"
            w={{ base: "100px", md: "400px" }}
            h={{ base: "200px", md: "250px" }}
            bg="radial-gradient(circle, #8B5CF6 0%, rgba(0,0,0,0) 70%)"
            filter="blur(80px)"
            zIndex={0}
          />
        </GridItem>
      </Grid>


      <Box mx={{ base: 2, md: 6 }} mt={{ base: 8, md: 20 }}>
        <Box
          textAlign="center"
          bg="rgba(255, 255, 255, 0.1)"   // white 10%
          backdropFilter="blur(10px)"    // optional: glass effect
          borderRadius="xl"
          p={{ base: 4, md: 8 }}         // padding around text
          w="fit-content"               // background only wraps content
          mx="auto"                     // center it
        >
          <Text
            color="white"
            fontSize={{ base: 28, md: 60, xl: 70 }}
            fontWeight="bold"
          >
            Casual And Competitive
          </Text>

          <Text
            color="white"
            fontSize={{ base: "16px", md: "21px" }}

            maxW={{ base: "320px", md: "600px" }}   // forces wrap to next line
            mx="auto"
          >
            Short, exciting games like 8 Pool, Ludo, and Rummy and Poker. Perfect for quick bursts of fun and tournament rewards!
          </Text>
        </Box>
      </Box>

      <Box position="relative" pt={"16"} overflow="hidden">
        {/* Purple glow background */}
        <Box
          position="absolute"
          top="25%"
          right="-1%"
          transform="translate(-60%, -60%)"
          w={{ base: "700px", md: "700px" }}
          h={{ base: "600px", md: "550px" }}
          bg="radial-gradient(circle, #8B5CF6 0%, rgba(0,0,0,0) 90%)"
          filter="blur(80px)"
          zIndex={0}
        />

        <Box position="relative" zIndex={1} mx="auto" px={{ base: 2, md: 16 }} id="games-section">
          {/* Top Flex: Title + Description */}
          <Flex
            direction={{ base: "column", xl: "row" }}
            align="center"
            justify="space-between"
            gap={{ md: 6 }}
            mb={8}
          >
            <Text
              bgGradient="linear(to-r, #FFFFFF, #BDA8FB)"
              bgClip="text"
              fontWeight="bold"
              fontSize={{ base: "80px", md: "126px" }}
            >
              GAMES
            </Text>

            <Text
              color="#A78BFA"
              maxW="900px"
              fontSize={{ base: "16px", md: "21px" }}
              lineHeight="1.7"
              letterSpacing="0.01em"
              align={{ base: "center", md: "start" }}

            >
              Bring you the most exciting and widely loved casual games in one action-packed
              mobile universe. Whether you're in the mood for a 30-second thrill or a quick
              mental workout, there's always something to play and something to win.
            </Text>
          </Flex>

          {/* Bottom Grid Cards */}
          <Box w="100%" position="relative" mt={6}>

            <Swiper
              modules={[Autoplay]}
              onSwiper={(swiper) => (swiperRef.current = swiper)}
              spaceBetween={-35}
              slidesPerView={4}
              loop={true}
              speed={700}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              breakpoints={{
                0: { slidesPerView: 1.2, spaceBetween: 10 },
                480: { slidesPerView: 2, spaceBetween: 10 },
                768: { slidesPerView: 3, spaceBetween: 10 },
                1024: { slidesPerView: 4, spaceBetween: 10 },
              }}
              style={{ paddingBottom: "35px", paddingTop: "35px", width: "100%" }}
            >
              {games.map((game, index) => (
                <SwiperSlide key={index} style={{ display: "flex", justifyContent: "center" }}>
                  <Box
                    as={RouterLink}
                    to={`/games/${game.name.toLowerCase()}`}
                    py={3}
                    px={5}
                    bg="rgba(255,255,255,0.08)"
                    backdropFilter="blur(12px)"
                    borderRadius="2xl"
                    border="2px solid rgba(255,255,255,0.2)"
                    textAlign="center"
                    w="285px"
                    flexShrink={0}
                    transition="0.3s ease"
                    cursor="pointer"
                    zIndex={1}
                    _hover={{
                      borderColor: "#A78BFA",
                      boxShadow: "0 0 25px rgba(167, 139, 250, 0.8)",
                      transform: "translateY(-4px) scale(1.02)",
                      textDecoration: "none",
                    }}
                  >
                    <Box borderRadius="xl" mb={4}>
                      <Image
                        src={game.image}
                        alt={game.name}
                        mx="auto"
                        objectFit="contain"
                        w={{ base: "80%", md: "100%" }}
                      />
                    </Box>

                    <Text
                      color="white"
                      fontWeight="extrabold"
                      fontSize={{ base: "22px", md: "28px" }}
                      letterSpacing="0.08em"
                      pb={2}
                    >
                      {game.name.toUpperCase()}
                    </Text>
                  </Box>
                </SwiperSlide>
              ))}
            </Swiper>
          </Box>



          <Box textAlign="center" mt={20} position={"relative"}>
            <Box
              position="absolute"
              top="30%"
              right="-300px"
              w="500px"
              h="300px"
              bg="radial-gradient(circle, #8B5CF6 0%, rgba(0,0,0,0) 70%)"
              filter="blur(120px)"
              zIndex={-1}
              pointerEvents="none"
            />
            <Text bgGradient="linear(to-r, #8B5CF6, #D946EF)"
              bgClip="text"
              fontWeight="bold"
              fontSize={{ base: "28px", md: "47px" }}>
              What Sets Us Apart
            </Text>
            <Text color="#9CA3AF" fontSize={{ base: "16px", md: "21px" }}>
              Everything you need to know
            </Text>
          </Box>

          <Grid
            mt={{ base: 5, md: 0 }}
            templateColumns={{ base: "1fr", sm: "1fr 1fr", xl: "repeat(4, 1fr)" }}
            gap={{ base: 4, md: 10, xl: 12 }}
          >
            {[
              {
                title: "Smart & Skill-Based ",
                desc: "Win with skill, not luck. Every decision matters.",
              },
              {
                title: "Non-Stop Rewards",
                desc: "Coins, contests, leaderboards, and referral bonuses.",
              },
              {
                title: "Stunning UI/UX",
                desc: "Futuristic design that feels like you're gaming in a galaxy of your own.",
              },
              {
                title: "Community-Powered",
                desc: "Chat, challenge, and grow with fellow players across the world.",
              },
            ].map((item, index) => (
              <Box
                key={index}
                p={{ base: 0, md: 6 }}
                mt={{ base: 0, md: 14 }}

              >
                <Text
                  textAlign={"center"}
                  fontSize="26px"
                  fontWeight="bold"
                  mb={1}
                  bgGradient="linear(to-r, #8B5CF6, #D946EF)"
                  bgClip="text"
                >
                  {item.title}
                </Text>

                <Text textAlign={"center"} color="#9CA3AF" fontSize={{ base: 16, md: 21 }} lineHeight="1">
                  {item.desc}
                </Text>
              </Box>
            ))}
          </Grid>


          <Box display={{ base: "none", lg: "block" }}>
            <Game />
          </Box>

          <Box position="relative" mx="auto" mt={{ base: 8, md: 4, lg: "-40px", xl: "-80px" }}>

            {/* IMAGE */}
            <Box position="relative" zIndex={1}>
              <Image
                src={Leaderboard}
                alt="Player"
                // w="100%"
                objectFit="contain"
              />
            </Box>

            {/* GLASS CARD */}
            <Box
              position={{ base: "relative", xl: "absolute" }}
              top={{ xl: "60%" }}
              left={{ xl: "64%" }}
              transform={{ xl: "translate(-50%, -50%)" }}
              mt={{ base: "-30px", md: "0px", xl: "0" }}
              w={{ base: "100%", md: "90%", xl: "700px" }}
              p={{ base: 6, md: 8 }}
              borderRadius="2xl"
              bg="rgba(255,255,255,0.08)"
              backdropFilter="blur(12px)"
              border="1px solid rgba(167,139,250,0.3)"
              zIndex={2}
            >

              <Flex align="center" justify="space-between" gap={6} >

                <Box >
                  <Text
                    fontSize={{ base: "22px", md: "38px" }}
                    fontWeight="bold"
                    mb={4}
                    bgGradient="linear(to-r, #FFFFFF, #BDA8FB)"
                    bgClip="text"


                  >
                    LEADERBOARD
                  </Text>

                  <Text
                    color="#D1D5DB" maxW="420px"
                    fontSize={{ base: "14px", md: "21px" }}

                  >
                    Rise Through the Ranks Your skill belongs on center stage.
                    Climb the Winnsta Global Leaderboards to earn exclusive badges
                    and "Legend" status. Every chip earned is a testament to your
                    strategy—show the community who really owns the arena.
                  </Text>
                </Box>

                {/* BADGE */}
                <Box
                  position="absolute"
                  right={{ base: "-1px", md: "-70%", xl: "-76%" }}
                  bottom={{ base: "150px", md: "0" }}
                  w={{ base: "70px", md: "100%" }}
                >
                  <Image
                    src={Victory}
                    alt="Rank Badge"
                  // w="100%"
                  />
                </Box>
              </Flex>



            </Box>

          </Box>

        </Box>
      </Box>


      {/* Testimonials Section */}
      <TrendingStories />

    </Box>
  );
};

export default HomeBanner;
